import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'

import * as components from './components'

@ngCore.Component({
  imports: [
    components.detailsTab.Component,
    components.mappingTab.Component,
    components.rulesTab.Component,
    ds.button.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
  ],
  selector: 'atn-rate-gl-record-slideout',
  standalone: true,
  styleUrls: ['./gl-record-slideout.component.scss'],
  templateUrl: './gl-record-slideout.component.html',
})
export class AtnGlRecordSlideoutComponent {
  /** @see {@link state.rate.gl.EcInjector} */
  public readonly glEc = ngCore.inject(state.rate.gl.records.Collection)

  /**
   * Removes selection a {@link models.rate.GlMappingRule}
   */
  public cancelBtnClickHandler = () => {
    this.glEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from('Gl.Slideout.Footer.CancelBtn.Clicked')
      .dispatch({ value: undefined })
  }
}
